function isActiveRefreshAccountNotFound(isFresh, response) {
    return isFresh === true
        && response != null
        && String(response.error) === "404";
}

function runSingleFlight(holder, key, action) {
    if (holder[key]) {
        return holder[key];
    }

    let actionPromise;
    try {
        actionPromise = Promise.resolve(action());
    } catch (error) {
        actionPromise = Promise.reject(error);
    }

    const guardedPromise = actionPromise.then(
        (result) => {
            if (holder[key] === guardedPromise) {
                holder[key] = null;
            }
            return result;
        },
        (error) => {
            if (holder[key] === guardedPromise) {
                holder[key] = null;
            }
            throw error;
        },
    );
    holder[key] = guardedPromise;
    return guardedPromise;
}

module.exports = {
    isActiveRefreshAccountNotFound,
    runSingleFlight,
};
